import { useState } from "react";
import classes from "./Filter.module.scss";
import OpportunityStatusList from "./OpportunityStatus.json";

const Filter = () => {
  const [selectedStatus, setSelectedStatus] = useState(0);
  return (
    <div
      className={`${classes["filter-wrapper"]} d-flex flex-column justify-content-between`}
    >
      <div className={classes["title"]}>My Opportunities</div>
      <div className="d-flex justify-content-between align-items-end">
        <div className={classes["tab-wrapper"]}>
          {OpportunityStatusList.map((item) => (
            <div
              className={`${classes["tab-item"]} ${
                item.id === selectedStatus ? classes["selected"] : ""
              }`}
              role={"button"}
              key={item.id}
              onClick={() => setSelectedStatus(item.id)}
            >
              {item.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Filter;
